import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { AttachmentRequestData } from '../../models/attachment-request-data'
import { Observable } from 'rxjs'
import { AttachmentResponseData } from '../../models/attachment-response-data'
import { AttachmentService } from '../../services/attachment.service'
import { map, switchMap, tap } from 'rxjs/operators'
import { UrlCollection } from '../../url-collection'
import { DialogService } from 'primeng/dynamicdialog'
import { PictureDialogComponent } from '../../modules/misc'
import { StoredEntityService } from '../../modules/entity-store-access'
import { StoredEntityStateService } from '../../modules/entity-store-access'

@Component({
  selector: 'jml-lib-attachment-list',
  templateUrl: './attachment-list.component.html',
  styleUrls: ['./attachment-list.component.scss']
})
export class AttachmentListComponent implements OnInit {
  // either receive attachment data from parent (for scenario with additional display like image galleria )
  // or define request data and this component requests the data.
  @Input() receiveDataFromParent = false

  @Input() documentTypeForHeader = 'Dokumente'
  @Input() attachmentType: string
  @Input() ownerType: string
  @Input() ownerId: number
  @Input() attachmentCategory?: string
  @Input() showPictureViewerOpenButton = false

  @Input() attachment: AttachmentResponseData
  @Output() attachmentRemoved = new EventEmitter<AttachmentRequestData>()

  attachments$: Observable<AttachmentResponseData>
  header: { field: string; header: string }[]
  content: string[][]
  content2: any[]
  selectedImageName = 'Image'
  displayImageViewer = false

  constructor(
    private attachmentService: AttachmentService,
    private storedEntityService: StoredEntityService,
    private storedEntityWrapper: StoredEntityStateService,
    private dialogService: DialogService
  ) {}

  ngOnInit() {
    console.log('AttachmentListComponent')
    if (this.receiveDataFromParent) {
      this.readAttachmentData(this.attachment)
    } else {
      this.requestAttachmentData()
    }
  }

  requestAttachmentData() {
    console.log('requestAttachmentData')
    const attachmentRequestData = {
      attachmentType: this.attachmentType,
      ownerType: this.ownerType,
      ownerId: this.ownerId,
      attachmentCategory: this.attachmentCategory
    }

    // this.attachments$ = this.attachmentService.getAllAttachments(attachmentRequestData)
    //   .pipe(
    //     // add err mgmt.
    //     map(response => response.result),
    //     tap(attachment => this.readAttachmentData(attachment))
    //   );

    // this.attachments$ = this.storedEntityService.getEntity$(this.ownerType, this.ownerId).pipe(
    this.attachments$ = this.storedEntityWrapper.entityUpdated$.pipe(
      tap(() => console.log('ENTITY UPDATED')),
      switchMap(() => this.attachmentService.getAllAttachments(attachmentRequestData)),
      // add err mgmt.
      map((response) => response.result),
      tap((attachment) => this.readAttachmentData(attachment))
    )
  }

  readAttachmentData(attachment: AttachmentResponseData): void {
    console.log('readAttachmentData')
    const { keys, values } = attachment.getDataKeysAndValues()
    this.header = keys.filter((key) => key !== 'id' && key !== '_repr_').map((key) => ({ field: key, header: key }))
    this.content = values
    this.content2 = values.map((row) => {
      const attObj = {}
      keys.forEach((key, pos) => {
        attObj[key] = row[pos]
      })
      // console.log('[attachment-list] attObj: ', attObj);
      return attObj
    })
    // console.log('[attachment-list] header: ', this.header);
    // console.log('[attachment-list] content: ', this.content);
  }

  /**
   * Method to request data update from parent element.
   *
   * @memberof AttachmentListComponent
   */
  public updateData(): void {
    this.requestAttachmentData()
  }

  downloadUrl(id: number): string {
    return UrlCollection.Files.generateDownloadUrl(id)
  }

  detachAndDeleteEntity(id: number): void {
    console.log('[AttachmentListComponent-detachAndDeleteEntity]')
    // detach
    // 	{
    //      "attachmentType" : "File",
    //      "attachmentId" : 12,
    //      "ownerType" : "Glass",
    //      "ownerId" : 9
    // }
    const attachmentRequest: AttachmentRequestData = {
      attachmentType: this.attachmentType,
      attachmentId: id,
      ownerType: this.ownerType,
      ownerId: this.ownerId
    }
    this.attachmentService.detachFromEntity(attachmentRequest).subscribe((_) => {
      // delete
      this.storedEntityService.deleteEntity$(this.attachmentType, id).subscribe((_) => {
        console.log(`successfully deleted ${this.attachmentType}`)
        this.updateData()
        this.attachmentRemoved.emit(attachmentRequest)
      })
    })
  }

  openImage(id: number): void {
    // this.selectedImageName = this.content2[id];
    // this.displayImageViewer = true;
    // console.log('content: ', this.content2[id]);
    console.log('[AttachmentListComponent-openImage] id: ', id)
    console.log('[AttachmentListComponent-openImage] content: ', JSON.stringify(this.content2))
    const attachment = this.content2.find((element) => element.id === id)
    const dialogRef = this.dialogService.open(PictureDialogComponent, {
      data: {
        fileId: id
      },
      header: `${attachment.fileName} - ${attachment.fileType}`,
      width: '80%',
      height: '70%'
    })
    dialogRef.onClose.subscribe((event) => {
      // anything?
    })
  }

  showImage(): void {}
}
